module.exports = __webpack_public_path__ + "img/Daftar-hover.f780a7e9.svg";